import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterSecondOpinion'
})
export class FilterSecondOpinionPipe implements PipeTransform {

 labels = {
  fr: [
    'Demande envoyée',
    'Demande vérifiée',
    'Envoyée au médecin',
    'En attente paiement',
    'En cours de traitement',
    'Rapport prêt'
  ],
  ar: [
    'تم إرسال الطلب',
    'تم التحقق من الطلب',
    'تم إرساله إلى الطبيب',
    'في انتظار الدفع',
    'قيد المعالجة',
    'التقرير جاهز'
  ]
};

transform(status: number, language: 'fr' | 'ar' = 'fr'): string {
  return this.labels[language]?.[status] ?? '';
}

}
